import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { FraudService } from '@shared/services/fraud.service';
import { MessageDisplayService } from '@shared/message-display/message-display.service';
import { ProfileService } from '@shared/services/profile.service';
import { UserService } from '@app/user/user.service';
import { AppCommonModule } from '@app/common/common.module';

@NgModule({
  imports: [
    CommonModule,
    MatSnackBarModule,
    TranslateModule,
    AppCommonModule,
  ],
  exports: [
    CommonModule,
    MatSnackBarModule,
    TranslateModule,
    AppCommonModule,
  ]
})
export class SharedModule {

  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        FraudService,
        UserService,
        MessageDisplayService,
        ProfileService,
      ],
    };
  }

}

